var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1054,
    height: 1054,
    viewBox: "0 0 1054 1054",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_757_2325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 527,
    cy: 527,
    r: 177,
    fill: "url(#paint0_linear_757_2325)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_757_2325",
    x: 0,
    y: 0,
    width: 1054,
    height: 1054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_757_2325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_757_2325",
    x1: 902.388,
    y1: 738.256,
    x2: 304.098,
    y2: 445.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.24bc5b1de77f5fd8c62df2f785e1555a.svg";
export { ForwardRef as ReactComponent };